import React, { useState } from 'react';
import calculatorImage from '../assets/calculators.png'; // Updated image
import NotifyPopup from '../common/NotifyPopup';

export default function Calculator() {
  const [popupVisible, setPopupVisible] = useState(false);

  return (
    <>
      <div style={styles.container}>
        <div style={styles.content}>
          <h1 style={styles.heading}>Financial Calculators Coming Soon</h1>
          <p style={styles.subheading}>
            Make informed financial decisions with our suite of calculators designed to help you manage your credit and finances.
          </p>
          <img src={calculatorImage} alt="Calculator Coming Soon" style={styles.image} />
          <button style={styles.notifyBtn} onClick={() => setPopupVisible(true)}>NOTIFY ME</button>
        </div>
      </div>
      <NotifyPopup visible={popupVisible} onClose={() => setPopupVisible(false)} />
    </>
  );
}

const styles = {
  container: {
    width: '100vw',
    minHeight: '100vh',
    backgroundColor: '#FFFFFF',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-start',
    padding: '120px 20px 40px', // Slightly moved down
    boxSizing: 'border-box',
  },
  content: {
    maxWidth: '680px',
    textAlign: 'center',
    width: '100%',
  },
  heading: {
    fontSize: '28px',
    fontWeight: '600',
    color: '#000000',
    marginBottom: '16px',
    fontFamily: 'sans-serif',
  },
  subheading: {
    fontSize: '16px',
    color: '#4A4A4A',
    lineHeight: '1.6',
    marginBottom: '40px',
    padding: '0 10px',
  },
  image: {
    width: '100%',
    maxWidth: '460px',
    height: 'auto',
    marginBottom: '40px',
  },
  notifyBtn: {
    backgroundColor: '#002D74',
    color: '#ffffff',
    border: 'none',
    padding: '12px 24px',
    fontSize: '14px',
    fontWeight: '600',
    borderRadius: '4px',
    cursor: 'pointer',
    display: 'block',
    margin: '0 auto', // 🔥 Centering the button
  },
};
